<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div>
        <div class="dashboard-title">User Activity Dashboard</div>
      </div>
    </div>
    <mat-divider class="divider-bottom"></mat-divider>
    <fc-display-table-filter #filterComponent
    ></fc-display-table-filter>
    <div class="table-container">
      <fc-display-table-base
        (quickFilter)="filterComponent.quickFilter($event)"
      ></fc-display-table-base>
    </div>
  </div>

  <mat-paginator
    itemLabel="Events"
    (page)="displayTableService.goToPage($event)"
    [showFirstLastButtons]="true"
    [length]="displayTableService.totalItems"
    [pageSize]="displayTableService.paginationTotal"
    [pageSizeOptions]="displayTableService.pageSizeOptions"
    [pageIndex]="displayTableService.currentPage - 1">
  </mat-paginator>
</div>
